export default "__VITE_ASSET__c8be655e__"